export default function TermosPage() {
    const sections = [
        {
            title: 'Aviso',
            body: 'As traduções publicadas no MediocreToons são feitas por fãs, para fãs, sem vínculo oficial com os detentores das obras.',
        },
        {
            title: 'Direitos autorais',
            body: 'Todos os direitos sobre personagens, histórias, nomes, logos e materiais originais pertencem exclusivamente aos autores, artistas e editoras oficiais.',
        },
        {
            title: 'Comentários e conduta',
            body: 'É proibido publicar conteúdo com violência explícita, ameaças, xingamentos, discurso de ódio, assédio ou qualquer material ofensivo nos comentários.',
        },
        {
            title: 'Responsabilidade do usuário',
            body: 'Cada usuário é responsável pelo conteúdo que publica. Em caso de violação das regras, o conteúdo pode ser removido e a conta pode sofrer punições.',
        },
        {
            title: 'Privacidade',
            body: 'Não publique dados pessoais seus ou de terceiros (telefone, endereço, documentos, e-mail privado ou outras informações sensíveis).',
        },
        {
            title: 'Spam',
            body: 'É proibido flood, propaganda não autorizada, repetição excessiva de mensagens e envio de links maliciosos.',
        },
        {
            title: 'Denúncia',
            body: 'Use os canais de denúncia e suporte para reportar abuso, violação de direitos e comportamento inadequado.',
        },
        {
            title: 'Medidas de moderação',
            body: 'A equipe pode remover conteúdo, limitar funcionalidades, suspender temporariamente ou banir contas em caso de infração.',
        },
    ];

    return (
        <div className="min-h-screen bg-black pb-28 lg:pb-12">
            <div className="max-w-2xl mx-auto px-5 pt-24 lg:pt-36 pb-12">
                <div className="mb-10">
                    <div className="flex items-center gap-4 mb-2">
                        <div className="h-10 w-1.5 shrink-0 rounded-full bg-orange-600" />
                        <h1 className="text-2xl font-black uppercase italic tracking-tighter text-white md:text-4xl">
                            Termos de uso
                        </h1>
                    </div>
                    <p className="mt-3 ml-5 text-[11px] font-black uppercase tracking-[0.3em] text-white/35">
                        Regras e diretrizes da plataforma
                    </p>
                </div>

                <div className="flex flex-col gap-6">
                    {sections.map((section) => (
                        <div
                            key={section.title}
                            className="rounded-2xl border border-white/[0.06] bg-white/[0.02] px-5 py-4"
                        >
                            <h2 className="text-sm font-bold uppercase tracking-widest text-orange-400 mb-2">
                                {section.title}
                            </h2>
                            <p className="text-sm text-white/70 leading-relaxed">
                                {section.body}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
